
    import Vue from "vue";
    import Component from "vue-class-component";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import VueRouter, {Route} from "vue-router";
    import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
    import {authService} from "@/AuthService";
    import LandingpageIllustration from "@/components/LandingpageIllustration.vue";
    import {factory, ResultError} from "@/api-client";

    @Component({
        components: {
            SectionPageHeading,
            TableEmptySlot,
            LandingpageIllustration
        },
    })
    export default class AccessLinkLogin extends Vue {
        secret = "";
        accessLinkToken: string | null = "";

        authService = authService;
        
        errors = factory.create(ResultError);

        async login() {
            this.errors.clear();
            if(!this.accessLinkToken){
                this.errors.appendMessage(this.$ls.SharedResources_Error_LogInAgain);
                return;
            }
            await authService.authenticateWithAccessLinkToken(this.accessLinkToken, this.secret)
                .then(async () => {
                    await this.$router.push(this.$route.query.returnUrl as string)
                        // Acknowledge Vue warnings that are generated when using navigation guards to redirect user to profile selection or auto-choose seafarer profile.
                        .catch((e) => {
                            const failureTypeRedirected = 1; // NavigationFailureTypeE.redirected
                            if (!VueRouter.isNavigationFailure(e, failureTypeRedirected)) {
                                Promise.resolve(e);
                            }
                        });
                })
                .catch(error => this.errors = error);
        }
        
        created(){
            this.accessLinkToken = sessionStorage.getItem('mis-access-link-token') ?? null;
            // Access token is not removed from session storage to enable language change.
        }
    }
